window.__stoke = window.__stoke || {};

window.__stoke.product = {
  slick: {
    el: $('#product__slider-images'),
    init: function() {
      const $slider = __stoke.product.slick.el;

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('destroy');
      }

      var $currentSlide = $slider.find('.slick-current');

      $slider.slick({
        dots: false,
        infinite: false,
        slidesToShow: 1,
        draggable: true,
        arrows: false,
        asNavFor: '#product__slider-nav'
      });

      $('#product__slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '#product__slider-images',
        dots: false,
        prevArrow: $('.slider-button--prev'),
        nextArrow: $('.slider-button--next'),
        focusOnSelect: true
      });
    },
    updateFilters: function() {
      const $slider = __stoke.product.slick.el
      const optionIndex = $slider.data('option-index');

      const variantSelector = document.querySelector('variant-selects')
        ? document.querySelector('variant-selects')
        : document.querySelector('variant-radios');

      let variant = variantSelector.currentVariant;
      
      if (!variant) {
        variantSelector.onVariantChange();
        variant = variantSelector.currentVariant;
      }

      let optionValue = '';
      switch (optionIndex) {
        case 1:
          optionValue = variant.option1;
          break;
        case 2:
          optionValue = variant.option2;
          break;
        case 3:
          optionValue = variant.option3;
          break;
        default:
          optionValue = variant.option1;
      }

      optionValue = Shopify.handleize(optionValue);

      if (optionValue !== $slider.data('selected-option')) {
        if ($slider.find(`[data-option="${optionValue}"]`).length == 0 && variant.featured_media) {
          var featuredMediaId = variant.featured_media.id;
          var activeIndex = $slider.find(`[data-slick-media-id="${featuredMediaId}"]`).data('slick-index');
          $slider.slick('slickGoTo', parseInt(activeIndex));
        }
      }
    },
    updateThumbs: function() {
      const $slider = __stoke.product.slick.el;
      const selectedOption = $slider.data('selected-option');
      const filteredThumbnails = Array.from($(`#product__slider-nav li[data-option="all"] span, #product__slider-nav li[data-option="${selectedOption}"] span`));
      const $thumbnails = $slider.find('.slick-dots li span');

      for (let thumbnail of $thumbnails) {
        let correspondingThumbnail = filteredThumbnails.shift();
        thumbnail.innerHTML = correspondingThumbnail.innerHTML;
      }
    }
  },
  stickyNavigation: {
    init: function() {
      $('.js-sticky-bar-navigation-item').click(function(e) {
        var $target = $($(this).attr('href'));

        if ($target.length) {
          e.preventDefault();

          $('html, body').animate({
            scrollTop: $target.offset().top - 150
          }, 500);
        }
      });

      var _lastScrollPosition = $(window).scrollTop();

      $(window).scroll(function() {
        var current = $(window).scrollTop();

        if (current > _lastScrollPosition) {
          if (current > $('.product-form').offset().top) {
            $('product-sticky-bar').addClass('bar-visible');
          }
        } else {
          $('product-sticky-bar').removeClass('bar-visible');
        }

        _lastScrollPosition = current;
      });
    }
  },
  tabs: {
    el: $('.product__tabs'),
    init: function() {
      $('.tab-list').each(function(){
        var $this = $(this);
        var $tab = $this.find('li.active');
        var $link = $tab.find('a');
        var $panel = $($link.attr('href'));

        $this.on('click', '.tab-control', function(e) {
          e.preventDefault();
          var $link = $(this),
              id = this.hash;
      
          if (id && !$link.is('.active')) {
            $panel.removeClass('active');
            $tab.removeClass('active');

            $panel = $(id).addClass('active');
            $tab = $link.parent().addClass('active');
          }
        });
      });
    }
  },
  ScrollToOffers: {
    el: $('#scroll-to-offers--button'),
    init: function() {
      const $button = __stoke.product.ScrollToOffers.el;
      var target = $button.attr('target');

      if (target && target.length) {
        $button.click(function(e) {
          document.querySelector(target).scrollIntoView({
            behavior: 'smooth'
          });
        });
      }
    }
  },
  offersSection: {
    el: $('.bundle-offers'),
    init: function() {
      let scrollButton = document.getElementsByClassName('scroll-button');
      let classicBundleButton = document.getElementById('classic-bundle--link');
      var i = 0, len = scrollButton.length;

      for(i ; i < len ; i++) {
        scrollButton[i].addEventListener('click', function(event){
          let target = this.getAttribute('target');
          document.querySelector(target).scrollIntoView({
              behavior: 'smooth'
          });
        });
      }

      if (classicBundleButton) {
        classicBundleButton.addEventListener('click', function(event){
          event.preventDefault();
          let target = this.getAttribute('href');
          let variantId = this.getAttribute('variant_id');

          if (window.location.href.indexOf('variant=') > -1) {
            var url = new URL(window.location.href);
            var searchParams = url.searchParams;

            searchParams.set('variant', variantId);
            url.search = searchParams.toString();
            window.location.replace(url?.toString());
          } else {
            window.location.replace(window.location.href + '?variant=' + variant_id);
          }
        });
      }
    }
  },
  defaultVariantChange: {
    el: $('variant-radios'),
    init: function() {
      if (window.location.href.indexOf('variant=') <= -1) {
        let Option1 = document.getElementById('template--16167945797832__main-Size-1');
        let Option2 = document.getElementById('template--16167945797832__main-Fuel Type-1');
        Option1.click();
        Option2.click();
      }
    }
  },
};

document.addEventListener('DOMContentLoaded', function() {
  __stoke.product.slick.init();
  __stoke.product.stickyNavigation.init();
  __stoke.product.tabs.init();
  __stoke.product.ScrollToOffers.init();
  __stoke.product.offersSection.init();
  __stoke.product.defaultVariantChange.init();

  var inCart = sessionStorage.getItem('data-in-cart');
  if (!inCart) {
    inCart = Math.floor(Math.random() * (30 - 5 + 1) + 5)

    sessionStorage.setItem('data-in-cart', inCart);
  }

  $('[data-in-cart]').text(inCart);
});

document.addEventListener('shopify:section:load', function() {
  __stoke.product.slick.init();
});

document.addEventListener('resize', __stoke.product.slick.init);
